import React, { useCallback, useMemo } from 'react';

import Zoom from '@mui/material/Zoom';
import { SnackbarProvider, useSnackbar } from 'notistack';

const SUCCESS = 'success';
const ERROR = 'error';
const WARNING = 'warning';
const INFO = 'info';

function useMessage() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showSuccessMessage = useCallback((message, options = {}) => {
    enqueueSnackbar(message, { ...options, variant: SUCCESS });
  }, [enqueueSnackbar]);

  const showErrorMessage = useCallback((message, options = {}) => {
    enqueueSnackbar(message, { ...options, variant: ERROR });
  }, [enqueueSnackbar]);

  const showWarningMessage = useCallback((message, options = {}) => {
    enqueueSnackbar(message, { ...options, variant: WARNING });
  }, [enqueueSnackbar]);

  const showInfoMessage = useCallback((message, options = {}) => {
    enqueueSnackbar(message, { ...options, variant: INFO });
  }, [enqueueSnackbar]);

  const closeMessage = useCallback((...args) => {
    closeSnackbar(...args);
  }, [closeSnackbar]);

  return useMemo(() => ({
    success: showSuccessMessage,
    error: showErrorMessage,
    warning: showWarningMessage,
    info: showInfoMessage,
    close: closeMessage,
  }), [closeMessage, showErrorMessage, showInfoMessage, showSuccessMessage, showWarningMessage]);
}

const CONFIG = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'right',
  },
  TransitionComponent: Zoom,
};

function MessageProvider({ children }) {
  return <SnackbarProvider {...CONFIG}>{children}</SnackbarProvider>;
}

export { MessageProvider, useMessage };
